import { GrowthToolService, GrowthToolServiceKey } from '@type-def_iqfu/dashboard/GrowthTool';

const note = '※ 送信後、営業担当より詳しいご案内をお送りします。';

export const growthToolServices: Record<GrowthToolServiceKey, GrowthToolService> = {
  lp: {
    menuLabel: '売却LP',
    name: '売却LP',
    tagline: '貴社専用の売却特化ランディングページ',
    description:
      '「売りたい」お客様だけを集める、貴社ブランドの売却専用ページを制作。WEB検索や広告、チラシのQRコードの受け皿として反響を最大化します。',
    points: [
      '貴社の売却実績・強みを打ち出した専用デザイン',
      'スマホ最適化&相談依頼フォーム標準搭載',
      '制作から公開まで丸ごとお任せ',
    ],
    recommendedFor: ['ホームページはあるが売却専門ページがない', '自社HPからの売却反響が少ない'],
    note,
  },
  ai: {
    menuLabel: 'AI査定',
    name: 'AI査定',
    tagline: '売出や成約データに基づく自動査定で出口価格の判断に',
    description: 'お客様が物件情報を入力すると詳細な出口価格を提示。',
    points: ['買取価格の判断材料に', '成約事例データに基づく高精度な概算査定', '47都道府県の全国対応'],
    recommendedFor: ['買付の初速で他社に負けたくない', '対応エリアの範囲を広げたい'],
    note,
  },
  kuchikomi: {
    menuLabel: '口コミ獲得',
    name: '口コミ獲得',
    tagline: 'お客様の声を集めて選ばれる会社に',
    description:
      '成約後のお客様から口コミを自動で収集し、自社HPやイクラ不動産に反映。第三者の評価が次の売却相談の後押しやMEO対策になります。',
    points: [
      '成約後アンケートの回答〜掲載まで自動化',
      'AIがお客様の回答を元にMEOに最適化した文章を自動生成',
      'イクラ不動産・自社HPの両方に反映可能',
    ],
    recommendedFor: ['実績はあるのに口コミが少ない', '口コミを頼みにくい', 'MEO順位を上げたい'],
    note,
  },
  interview: {
    menuLabel: 'インタビュー記事',
    name: 'インタビュー記事',
    tagline: '「この会社に任せたい」を作る記事コンテンツ',
    description: 'プロのライターが代表者様を取材し、信頼感の伝わる記事として公開。指名での相談につなげます。',
    points: [
      '取材・執筆・撮影まで丸ごとお任せ',
      'イクラ不動産の会社ページ・自社HPで活用可能',
      '担当者の人柄が伝わり成約率の高い指名相談が増える',
    ],
    recommendedFor: ['担当者の顔が見える集客がしたい', '他社との差別化ポイントを打ち出したい'],
    note,
  },
};

export const growthToolServiceKeys = Object.keys(growthToolServices) as GrowthToolServiceKey[];
